import { create } from "zustand";

export type CopyDropOverlayGeometry = {
    start: number,
    left: number,
    top: number,
    topNote: number,
    width: number,
    height: number
};

export type CopyDropOverlayGeometryStore = {
    geometry?: CopyDropOverlayGeometry,
    dropIsActive: boolean,
    setGeometry: (geometry: CopyDropOverlayGeometry) => void,
    setIsActive: (isActive: boolean) => void
};

export const copyDropOverlayGeometryStore = create<CopyDropOverlayGeometryStore>((set) => ({
    geometry: {
        start: 0,
        left: 0,
        top: 0,
        topNote: 0,
        width: 0,
        height: 0
    },
    dropIsActive: false,
    setGeometry: (geometry) => set({ geometry }),
    setIsActive: (isActive: boolean) => set({ dropIsActive: isActive })
}));

export const useCopyDropOverlayGeometryStore = () => {
    return copyDropOverlayGeometryStore((state) => ({
        geometry: state.geometry,
        dropIsActive: state.dropIsActive,
        setGeometry: state.setGeometry,
    }));
}
export const useCopyDropOverlayGeometry = () => {
    return copyDropOverlayGeometryStore((state) => state.geometry);
}
export const useSetCopyDropOverlayGeometry = () => {
    return copyDropOverlayGeometryStore((state) => state.setGeometry);
}

export const useCopyDropOverlayIsActive = () => {
    return copyDropOverlayGeometryStore((state) => state.dropIsActive);
}

export const useSetCopyBufferOverlayIsActive = () => {
    return copyDropOverlayGeometryStore((state) => state.setIsActive);
}